module.exports = __webpack_public_path__ + "static/media/citrus-alpha-features.f6bce8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/citrus-alpha-features.png
// module id = 258
// module chunks = 1